import React, {useEffect, useState} from 'react'
import {useParams} from "react-router";
import Loading from "components/Loading";
import scrollTo from "libs/scrollTo";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import PurchasingGroupStage1BasicDataForm from "./PurchasingGroupStage1BasicDataForm";
import Form from "components/Form";
import VS from 'constants/ValidationShema';
import SaveFormikValues from "components/SaveFormikValues";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import RouterPath from "libs/RouterPath";
import useSnackbar from "hooks/useSnackbar";
import Tr from "translations/Translations"
import GridBlock from "components/GridBlock";
import HistoryButton from "components/button/HistoryButton";
import HistoryListPopup from "components/popup/historyListPopup/HistoryListPopup";
import propertyTransformer from "./history/propertyTransformer";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import DemandValidationMessages from "components/DemandValidationMessages";

function PurchasingGroupStage1BasicData(
    {
        panelRef,
        validationSection,
        purchasingGroupHeader
    }) {

    const params = useParams();
    const groupId = params.id;
    const formId = params.section;
    const disabled = !validationSection.editable;
    const {enqueueSuccessSnackbar} = useSnackbar();
    const [basicData, setBasicData] = useState();
    const [history, setHistory] = useState();

    useStepperStateCloseValidator(formId);

    useEffect(() => {
        if (!!basicData) {
            setTimeout((elem) => scrollTo(elem, 30), 100, panelRef.current);
        }
        // eslint-disable-next-line
    }, [basicData]);

    useEffect(() => {
        if (groupId > 0)
            PurchasingGroupSectionService.getSections(groupId, validationSection.section)

        PurchasingGroupStage1Service.getBasicData(groupId).then((resp) => {
            if (resp)
                setBasicData(resp);
            else
                closeSection(groupId);
        });
    }, [groupId, validationSection.section]);

    const closeSection = (id) => RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.purchasingGroup.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR, {
        id: id,
        stage: 1
    }))

    const handleSubmit = (values) => {
        PurchasingGroupStage1Service.saveBasicData(groupId, values).then((result) => {
            if (result) {
                enqueueSuccessSnackbar(Tr("saved") + " " + validationSection.name);
                closeSection(result);
            }
        })
    }

    const loadHistoryList = async () => {
        try {
            return await PurchasingGroupStage1Service.getArchiveList(groupId, validationSection.section)
        } catch (e) {
            setHistory(false);
        }
    }

    const loadHistoryElement = async (archiveId) => {
        return await PurchasingGroupStage1Service.getArchiveElement(groupId, validationSection.section, archiveId);
    }


    if (!basicData) return <Loading/>;

    return (<>
        <DemandValidationMessages editable={validationSection.editable} section={validationSection}/>
        <Form
            id={formId}
            initialValues={basicData.purchasingGroup}
            validationSchema={VS.object({
                name: VS.stringMax(400).nullable(),
                description: VS.stringMax(4000).nullable(),
                number: basicData.numberingAutomated ? VS.any() : VS.stringMax(50).nullable(),
                organization: VS.anyRequired()
            })}
            onSubmit={handleSubmit}
        >
            {(formikProps) => (
                <>
                    {
                        (!disabled && groupId > 0) && <GridBlock justify="flex-end">
                            <HistoryButton onClick={() => setHistory(true)}>
                                {Tr('change_history')}
                            </HistoryButton>
                        </GridBlock>
                    }

                    <SaveFormikValues
                        formikProps={formikProps}
                        id={formId}
                    />
                    <PurchasingGroupStage1BasicDataForm basicData={basicData} formikProps={formikProps} disabled={disabled}/>
                </>)}
        </Form>

        {!!history && <HistoryListPopup loadHistoryElement={loadHistoryElement} loadHistoryList={loadHistoryList} onClose={() => setHistory(false)}
                                        propertyTransformer={propertyTransformer}/>}
    </>)
}

PurchasingGroupStage1BasicData.propTypes = {}

export default PurchasingGroupStage1BasicData;